/* Holy Gels — Over-40 PDP behaviour. Vanilla, idempotent, self-healing for the theme editor.
   Drives: review ticker, hero gallery (swipe + thumbs), horizontal rails, plan selector, FAQ tabs. */
(function () {
  'use strict';

  /* ---------- Review ticker: clone the track once for a seamless loop ---------- */
  function initTicker(root) {
    root.querySelectorAll('[data-tick-track]').forEach(function (track) {
      if (track.dataset.tickReady === '1') return;
      var src = track.querySelector('[data-tick-src]');
      if (!src) return;
      var old = track.querySelector('[data-tick-mirror]');
      if (old) old.remove();
      var clone = src.cloneNode(true);
      clone.removeAttribute('data-tick-src');
      clone.setAttribute('data-tick-mirror', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      track.dataset.tickReady = '1';
    });
  }

  /* ---------- Hero gallery: main scroll-snap track + synced thumbnail strip ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-gallery]').forEach(function (gal) {
      if (gal.dataset.galReady === '1') return;
      gal.dataset.galReady = '1';
      var stage = gal.querySelector('[data-gal]');
      var strip = gal.querySelector('[data-gthumbs]');
      var thumbs = strip ? [].slice.call(strip.querySelectorAll('[data-gthumb]')) : [];
      var counter = gal.querySelector('[data-gcount]');
      if (!stage) return;

      function setActive(i) {
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        if (counter) {
          var total = stage.children.length;
          counter.textContent = (i + 1) + ' / ' + total;
        }
        var el = thumbs[i];
        if (el && strip) {
          strip.scrollTo({ left: el.offsetLeft - (strip.clientWidth - el.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
          setActive(i);
        });
      });
      var raf;
      stage.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(stage.scrollLeft / stage.clientWidth);
          setActive(i);
        });
      });
      setActive(0);
    });
  }

  /* ---------- Horizontal rails: prev / next arrows ---------- */
  function initRails(root) {
    root.querySelectorAll('[data-rail-wrap]').forEach(function (wrap) {
      if (wrap.dataset.railReady === '1') return;
      wrap.dataset.railReady = '1';
      var rail = wrap.querySelector('[data-hrail]');
      if (!rail) return;
      function step(dir) {
        var card = rail.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.9;
        rail.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var prev = wrap.querySelector('[data-rail-prev]');
      var next = wrap.querySelector('[data-rail-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  /* ---------- Plan selector: pick a set count, update price + hidden inputs ---------- */
  function initPlans(root) {
    root.querySelectorAll('[data-plan-group]').forEach(function (group) {
      if (group.dataset.planReady === '1') return;
      group.dataset.planReady = '1';
      var rows = [].slice.call(group.querySelectorAll('[data-plan]'));
      var priceEl = group.querySelector('[data-price-now]');
      var wasEl = group.querySelector('[data-price-was]');
      var variantInput = group.querySelector('[data-variant-input]');
      var planInput = group.querySelector('[data-plan-input]');
      function select(row) {
        rows.forEach(function (r) { r.setAttribute('aria-checked', r === row ? 'true' : 'false'); });
        if (priceEl && row.dataset.priceNow) priceEl.textContent = row.dataset.priceNow;
        if (wasEl && row.dataset.priceWas) wasEl.textContent = row.dataset.priceWas;
        if (variantInput && row.dataset.variant) variantInput.value = row.dataset.variant;
        if (planInput) planInput.value = row.dataset.plan || '';
      }
      rows.forEach(function (row) {
        row.addEventListener('click', function () { select(row); syncNativeSet(row.dataset.sets); updateOneTimePrice(); swapHeroImage1(row.dataset.sets); });
        row.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(row); syncNativeSet(row.dataset.sets); updateOneTimePrice(); swapHeroImage1(row.dataset.sets); }
        });
      });
      var pre = group.querySelector('[data-plan][aria-checked="true"]') || rows[0];
      if (pre) select(pre); // visual preselect only; native default_set already matches
      updateOneTimePrice();
      if (pre) swapHeroImage1(pre.dataset.sets);
    });
  }

  /* ---------- Bridge to the theme's native Recharge bundle picker ----------
     The hidden #shopify-section-subbuybox renders .subscription-bundle / .one-time-bundle
     with .bundle-group[data-bundle-set] + .bundle-product slots and the correct
     product/variant/selling-plan binding. The popup (#bundle-collection-popup) fills those
     slots; its own "Add To Cart" builds the Recharge bundle and checks out. We only steer
     which set + purchase type is active, then hand off to the theme's own entry point. */
  function nativeReady() {
    return !!(document.getElementById('bundle-collection-popup') &&
              document.querySelector('.subscription-bundle, .one-time-bundle'));
  }
  // hero "N Sets" -> native target set-(N-1): 2->set-1, 3->set-2, 4->set-3 (slots == sets == designs)
  function nativeTargetForSets(sets) {
    var n = parseInt(sets, 10);
    return n ? 'set-' + (n - 1) : null;
  }
  function setPurchaseType(type) {
    // Set .active authoritatively so getCurrentPurchaseType() returns the right type,
    // and toggle the bundle sections so getActiveBundleGroup() reads the correct one.
    document.querySelectorAll('.purchase-type[data-type]').forEach(function (b) {
      b.classList.toggle('active', b.dataset.type === type);
    });
    document.querySelectorAll('.one-time-bundle').forEach(function (el) { el.classList.toggle('hidden', type !== 'one-time'); });
    document.querySelectorAll('.subscription-bundle').forEach(function (el) { el.classList.toggle('hidden', type === 'one-time'); });
  }
  function syncNativeSet(sets) {
    if (!nativeReady()) return;
    var target = nativeTargetForSets(sets);
    if (!target) return;
    var opt = document.querySelector('.bundle-selector .bundle-option[data-target="' + target + '"]');
    if (opt) opt.click(); // recharge-builder listener syncs groups in BOTH bundle sections
    // Also toggle groups directly (covers one-time + the no-selector fallback).
    document.querySelectorAll('.subscription-bundle .bundle-group[data-bundle-set], .one-time-bundle .bundle-group[data-bundle-set]').forEach(function (g) {
      var on = g.getAttribute('data-bundle-set') === target;
      g.classList.toggle('active', on);
      g.classList.toggle('hidden', !on);
    });
  }
  // Reflect the selected set's one-time price on the secondary CTA (e.g. " · £59.00").
  function updateOneTimePrice() {
    var row = document.querySelector('[data-plan-group] [data-plan][aria-checked="true"]');
    var price = row ? (row.dataset.onetimePrice || '') : '';
    document.querySelectorAll('[data-cta2-price]').forEach(function (el) {
      el.textContent = price ? ' · ' + price : '';
    });
  }
  function currentHeroSets() {
    var row = document.querySelector('[data-plan-group] [data-plan][aria-checked="true"]');
    return row ? row.dataset.sets : null;
  }
  // Swap the first gallery slide + its thumbnail to the image for the selected set (4/3/2).
  // Falls back to the 4-set/default image (data-gvar="4") when that set has no variant image.
  function swapHeroImage1(sets) {
    var want = String(sets || '4');
    ['[data-gslide1]', '[data-gthumb1]'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (box) {
        var imgs = [].slice.call(box.querySelectorAll('img[data-gvar]'));
        if (!imgs.length) return;
        var match = null, base = null;
        imgs.forEach(function (im) {
          if (im.dataset.gvar === want) match = im;
          if (im.dataset.gvar === '4') base = im;
        });
        match = match || base || imgs[0];
        imgs.forEach(function (im) { im.style.display = (im === match) ? '' : 'none'; });
      });
    });
  }
  function openPicker(type) {
    if (!nativeReady()) return false; // no native machinery on page -> let <a href> fall back
    setPurchaseType(type === 'one-time' ? 'one-time' : 'subscription');
    syncNativeSet(currentHeroSets());
    // buildRechargeBundle() opens the picker when slots are empty, else adds to cart.
    if (typeof window.buildRechargeBundle === 'function') { window.buildRechargeBundle(); return true; }
    if (typeof window.bundlePopup_openNextEmptySlot === 'function') { window.bundlePopup_openNextEmptySlot(); return true; }
    return false;
  }
  function initPicker(root) {
    root.querySelectorAll('[data-hg-open-picker]').forEach(function (a) {
      if (a.dataset.pickReady === '1') return;
      a.dataset.pickReady = '1';
      a.addEventListener('click', function (e) {
        if (openPicker(a.getAttribute('data-hg-open-picker') || 'subscription')) e.preventDefault();
      });
    });
  }

  /* ---------- FAQ tabs ---------- */
  function initFaqTabs(root) {
    root.querySelectorAll('[data-faqtabs]').forEach(function (wrap) {
      if (wrap.dataset.faqReady === '1') return;
      wrap.dataset.faqReady = '1';
      var tabs = [].slice.call(wrap.querySelectorAll('[data-faqtab]'));
      var panels = [].slice.call(wrap.querySelectorAll('[data-faqpanel]'));
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
          panels.forEach(function (p, n) { p.setAttribute('data-active', n === i ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- Autoplay looping videos (science media, hero circles) ----------
     Browsers allow muted autoplay but often need a JS nudge (iOS Safari especially)
     and defer offscreen playback. Play each framed autoplay video when it scrolls in. */
  function initAutoplay(root) {
    var vids = root.querySelectorAll('.hg-frame video');
    if (!vids.length) return;
    function play(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) play(e.target); });
    }, { threshold: 0.15 }) : null;
    vids.forEach(function (v) {
      if (v.dataset.hgAuto === '1' || !v.autoplay) return;
      v.dataset.hgAuto = '1';
      v.setAttribute('playsinline', '');
      if (io) io.observe(v);
      play(v);
    });
  }

  function initAll(root) {
    root = root || document;
    initTicker(root);
    initGallery(root);
    initRails(root);
    initPlans(root);
    initFaqTabs(root);
    initPicker(root);
    initAutoplay(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  // Theme editor: re-init the section that just (re)rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
